import React from "react";

import styles from "./BackgroundImage.module.scss";

import img1920x1080 from "../../assets/02_imgs/1920-1080.jpg";
import img1800x1080 from "../../assets/02_imgs/1800-1080.jpg";
import img1700x1080 from "../../assets/02_imgs/1700-1080.jpg";
import img1500x1080 from "../../assets/02_imgs/1500-1080.jpg";
import img1300x1080 from "../../assets/02_imgs/1300-1080.jpg";
import img1100x1080 from "../../assets/02_imgs/1100-1080.jpg";

function BackgroundImage() {
  return (
    <picture>
      <source media="(max-width: 640px)" srcSet={img1100x1080} />
      <source media="(max-width: 680px)" srcSet={img1300x1080} />
      <source media="(max-width: 780px)" srcSet={img1500x1080} />
      <source media="(max-width: 840px)" srcSet={img1700x1080} />
      <source media="(max-width: 900px)" srcSet={img1800x1080} />
      <img
        className={styles["background"]}
        src={img1920x1080}
        alt="Background"
      />
    </picture>
  );
}

export default BackgroundImage;
